import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormService } from 'src/app/services/form.service';
import { FormGroup } from '@angular/forms';
import { ModalService } from 'src/app/services/modal.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { AppConstants } from 'src/app/app.constants';
import { ClipboardService } from 'ngx-clipboard';
import { UtilsService } from 'src/app/services/utils.service';
import Stepper from 'bs-stepper';
import { AfterViewInit } from '@angular/core';
import { ElementRef } from '@angular/core';

@Component({
  selector: 'app-votacionfullmodal',
  templateUrl: './votacionfullmodal.component.html',
  styleUrls: ['./votacionfullmodal.component.css']
})
export class VotacionfullmodalComponent implements OnInit, AfterViewInit {

  @Input() data;
  form: FormGroup;
  submitted: Boolean = false;
  comboList: any;
  picture: any;
  combosList: any;
  stepperForm: Stepper;

  constructor(private activeModal: NgbActiveModal, private formService: FormService, private modal: ModalService,
    private alert: NotificacionesService, private utils: UtilsService, private clipboard: ClipboardService, private elementRef: ElementRef) {
    this.comboList = [{ id: 1, name: 'Estatus 1' }, { id: 2, name: 'Estatus 2' }, { id: 3, name: 'Estatus 3' }];
    this.combosList = [];
    this.combosList.push(this.comboList);
  }

  ngOnInit(): void {
    this.form = this.formService.getVotacionesFullModalForm(this.data, this.combosList);
    this.modal.mostrarModalCargando();
    // this.catalogService.findAllPersonType().subscribe((data: any) => {
    // this.comboList = data;
    // this.combosList.push(this.comboList);
    // this.form = this.formService.getVotacionesFullModalForm(this.data, this.combosList);
    this.modal.cerrarModalCargando();
    // }, (error: any) => {
    //   console.error('Error', error);
    //   this.modal.cerrarModalCargando();
    // });
  }

  accept() {
    this.submitted = true;
    if (this.form.invalid)
      return;
    this.modal.mostrarModalCargando();
    if (this.form.value.id > 0)
      this.update(this.form.value);
    else
      this.save(this.form.value);
  }

  save(llaves) {
    this.modal.cerrarModalCargando();
    // this.personService.save(llaves).subscribe((data: any) => {
    // if (data.responseCode === AppConstants.RESPONSECODES.OK)
    //   this.alert.success(data.message, true);
    // else
    //   this.alert.error(data.message, true);
    // this.modal.cerrarModalCargando();
    this.close();
    // }, (error: any) => {
    //   console.error('Error', error);
    //   this.modal.cerrarModalCargando();
    // });
  }

  update(llaves) {
    this.modal.cerrarModalCargando();
    // this.personService.update(llaves).subscribe((data: any) => {
    //   if (data.responseCode === AppConstants.RESPONSECODES.OK)
    //     this.alert.success(data.message, true);
    //   else
    //     this.alert.error(data.message, true);
    //   this.modal.cerrarModalCargando();
    this.close();
    // }, (error: any) => {
    //   console.error('Error', error);
    //   this.modal.cerrarModalCargando();
    // });
  }

  dismiss() {
    this.activeModal.dismiss();
  }

  close() {
    this.activeModal.close();
  }

  next() {
    this.stepperForm.next();
  }

  previous() {
    this.stepperForm.previous();
  }

  ngAfterViewInit() {
    this.stepperForm = new Stepper(document.querySelector('#stepperForm'), {
      linear: false,
      animation: true
    });
  }

  onSubmit() {
    return false;
  }

}
